import { render, staticRenderFns } from "./WorkshopDetails.vue?vue&type=template&id=0e586a68&scoped=true&"
import script from "./WorkshopDetails.vue?vue&type=script&lang=ts&"
export * from "./WorkshopDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e586a68",
  null
  
)

export default component.exports